<div class="feedback-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner"></div>
    <p>Loading survey...</p>
  </div>

  <!-- Survey Form -->
  <div *ngIf="!isLoading && surveyDetail" class="feedback-form-wrapper">
    <!-- Header -->
    <div class="feedback-header">
      <button class="back-btn" (click)="goBack()">
        <i class="fas fa-arrow-left"></i> Back
      </button>
      <h2>{{ surveyDetail.survey_title }}</h2>
      <p class="survey-description">{{ surveyDetail.survey_description }}</p>
      <div class="customer-info">
        <strong>Customer:</strong> {{ surveyDetail.customer_name }}
      </div>
    </div>

    <!-- Feedback Form -->
    <form [formGroup]="feedbackForm" (ngSubmit)="submitFeedback()">
      <!-- Questionnaire Sets -->
      <div class="questionnaire-sets">
        <div *ngFor="let set of surveyDetail.questionnaire_sets; let setIndex = index" 
             class="questionnaire-set">
          <h3 class="set-title">{{ set.set_name }}</h3>

          <!-- Questions -->
          <div class="questions-list">
            <div *ngFor="let question of set.questions; let qIndex = index" 
                 class="question-item">
              <div class="question-header">
                <span class="question-number">Q{{ qIndex + 1 }}</span>
                <span class="question-text">
                  {{ question.question_text }}
                  <span *ngIf="question.is_required" class="required-mark">*</span>
                </span>
              </div>

              <!-- Star Rating Question -->
              <div *ngIf="question.question_type === 'star_rating'" class="answer-section">
                <div class="star-rating">
                  <span *ngFor="let star of [1, 2, 3, 4, 5]" 
                        class="star" 
                        [class.filled]="star <= getStarRating(set.set_id, question.question_id)"
                        (click)="setStarRating(set.set_id, question.question_id, star)">
                    ★
                  </span>
                  <span class="rating-value" *ngIf="getStarRating(set.set_id, question.question_id) > 0">
                    {{ getStarRating(set.set_id, question.question_id) }}/5
                  </span>
                </div>
                <div *ngIf="getAnswerControl(set.set_id, question.question_id)?.get('star_rating')?.touched && 
                           getAnswerControl(set.set_id, question.question_id)?.get('star_rating')?.invalid" 
                     class="error-message">
                  This question is required
                </div>
              </div>

              <!-- Text Question -->
              <div *ngIf="question.question_type === 'text'" class="answer-section">
                <textarea 
                  [formControl]="getTextAnswerControl(set.set_id, question.question_id)"
                  class="text-input"
                  rows="4"
                  placeholder="Enter your answer here...">
                </textarea>
                <div *ngIf="getAnswerControl(set.set_id, question.question_id)?.get('text_answer')?.touched && 
                           getAnswerControl(set.set_id, question.question_id)?.get('text_answer')?.invalid" 
                     class="error-message">
                  This question is required
                </div>
              </div>

              <!-- Multiple Choice Question -->
              <div *ngIf="question.question_type === 'multiple_choice'" class="answer-section">
                <div class="radio-group">
                  <label *ngFor="let option of question.options" class="radio-option">
                    <input 
                      type="radio" 
                      [formControl]="getSelectedOptionControl(set.set_id, question.question_id)"
                      [value]="option"
                      name="question_{{ question.question_id }}">
                    <span>{{ option }}</span>
                  </label>
                </div>
                <div *ngIf="getAnswerControl(set.set_id, question.question_id)?.get('selected_option')?.touched && 
                           getAnswerControl(set.set_id, question.question_id)?.get('selected_option')?.invalid" 
                     class="error-message">
                  This question is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Remarks Section -->
      <div class="remarks-section">
        <label for="remarks">Additional Remarks (Optional)</label>
        <textarea 
          id="remarks"
          formControlName="remarks"
          class="remarks-input"
          rows="4"
          placeholder="Add any additional comments or feedback...">
        </textarea>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button type="button" class="btn-cancel" (click)="goBack()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button type="submit" class="btn-submit" [disabled]="isSubmitting">
          <span *ngIf="!isSubmitting">Submit Feedback</span>
          <span *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i> Submitting...
          </span>
        </button>
      </div>
    </form>
  </div>
</div>